import { Navigate, useLocation } from 'react-router-dom';
import { useTutorialPreferences } from '../hooks/useTutorialPreferences';
import { Loading } from '@/components/ui/loading';
import { RequirePlan } from '@/features/auth/middleware/RequirePlan';

interface TutorialGuardProps {
  children: React.ReactNode;
}

export const TutorialGuard = ({ children }: TutorialGuardProps) => {
  const { isLoading } = useTutorialPreferences();
  const location = useLocation();
  const isTutorialPage = location.pathname === '/tutorial';

  console.log('TutorialGuard:', {
    isLoading,
    tutorialCompleted: true, // Forçando como true para desativar o tutorial
    currentPath: location.pathname,
    isTutorialPage,
    state: location.state
  });

  if (isLoading) {
    return <Loading />;
  }

  // Se estiver na página do tutorial, redireciona para o dashboard
  if (isTutorialPage) {
    return <Navigate to="/dashboard" replace />;
  }

  // Envolvendo o conteúdo com RequirePlan para verificar se o usuário tem um plano
  return <RequirePlan>{children}</RequirePlan>;
}; 